import { TextInputComponent } from "components";
import { useFormProvider } from "../../../../providers";
import { useSerialNumber } from "hooks";

export function DeviceComponent() {
  const { serialNumber } = useFormProvider();
  const { serialNumber: mSerialNumber } = useSerialNumber({ serialNumber });

  return (
    <TextInputComponent
      label="Jenis Perangkat"
      value={mSerialNumber && mSerialNumber.device.name}
      disabled
    />
  );
}
